<script lang="typescript">
  import type { Meeting } from './customer-calendar-types';
  import {marked} from 'marked';
  export let onlyOneMeeting:boolean;
  export let meeting:Meeting;
  $: description = marked.parse(meeting.description);
</script>

<div class="meeting" class:onlyonemeeting={onlyOneMeeting}>
  <div>
    <div class="top">
      <h3>{meeting.title}</h3>
      <p class="price-and-duration"><span class="price">{meeting.price} €</span> <span class="duration"> / {meeting.duration}&nbsp;minuuttia</span></p>
      <p class="description">{@html description}</p>
      <p class="supervisor"><span class="supervisor-label">Ohjaajana</span> <span class="supervisor-name">{meeting.supervisor}</span></p>
    </div>
    <div class="bottom">
      <p class="buy"><a href="{meeting.product_link}">Tee ajanvaraus</a></p>
    </div>
  </div>
</div>

<style>

  .meeting {
    width: 50%;
  }

  .onlyonemeeting {
    width: 100%;
  }

  .meeting>div {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media screen and (max-width: 720px) {
    .meeting {
      width: 100%;
    }
  }
</style>

